import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LockIcon from '@material-ui/icons/Lock'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'
import PrimaryRouterLink from 'app/components/buttons/PrimaryRouterLink'
import { Routes } from 'app/services/routeService/routeService'

const useStyles = makeStyles((theme) => ({
  lockIcon: ({ iconSize }) => ({
    fontSize: iconSize === 'sm' ? '2.4rem' : '5.6rem',
  }),
  title: {
    color: theme.palette.darkGrey.main,
    fontSize: '1.4rem',
  },
  subtitle: {
    color: theme.palette.darkGrey.main,
    fontSize: '1.0rem',
  },
}))

const PaidPlanAccessBlock = ({ titleId, subtitleId, iconSize }) => {
  const classes = useStyles({ iconSize })

  const messageValues = {
    l: (text) => (
      <PrimaryRouterLink
        to={Routes.billingchangePlan()}
        className="underline flex bg-transparent justify-center p-5 text-14 font-bold"
      >
        {text}
      </PrimaryRouterLink>
    ),
  }

  return (
    <div className="flex items-center">
      <LockIcon className={classes.lockIcon}>lock</LockIcon>
      <div className="flex flex-col ltr:ml-16 rtl:mr-16 ">
        <span className={clsx(classes.title, 'leading-snug')}>
          <FormattedMessage id={titleId} values={messageValues} />
        </span>
        {subtitleId && (
          <span className={clsx(classes.subtitle, 'mt-8 leading-snug')}>
            <FormattedMessage id={subtitleId} values={messageValues} />
          </span>
        )}
      </div>
    </div>
  )
}

export default PaidPlanAccessBlock
